import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { BookingProvider } from "./context/BookingContext";
import { ModalProvider } from "./context/ModalContext";

import "./index.css";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <ThemeProvider>
      <HelmetProvider>
        <BrowserRouter>
          <BookingProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </BookingProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  // </React.StrictMode>
);
